module.exports = __webpack_public_path__ + "2337b562de57aba4fcc490e393b7cf90.gif";